import { serviceStatuses } from 'types/timetableServices';

export const getTrainServiceStatusMessage = (serviceStatus) => {
  switch (serviceStatus) {
    case serviceStatuses.CANCELLED:
      return 'liveTrainsInformation.cancelled';
    case serviceStatuses.LIMITED_SERVICE:
      return 'liveTrainsInformation.moreInformation';
    case serviceStatuses.SEATING_CHANGED:
      return 'liveTrainsInformation.trainSwapWarning';
    case serviceStatuses.UNAFFECTED:
    default:
      return 'liveTrainsInformation.allStations';
  }
};

export const getTrainServiceStatusIcon = (serviceStatus) => {
  switch (serviceStatus) {
    case serviceStatuses.CANCELLED:
      return 'Exclamation';
    case serviceStatuses.LIMITED_SERVICE:
    case serviceStatuses.SEATING_CHANGED:
      return 'WarningTriangle';
    case serviceStatuses.UNAFFECTED:
    default:
      return null;
  }
};
